import { FeatureFlags } from "./context";

export const FEATURE_CONFIGS: Record<string, FeatureFlags> = {
  consumer: {
    designsPerDay: 1,
    stylesAvailable: ["cut_flower", "pollinator", "drought_tolerant", "native"],
    seasonalViews: false,
    realTimeEditing: false,
    savedDesigns: 3,
    emailRequired: true,
    inventoryIntegration: false,
    clientManagement: false,
    proposalGeneration: false,
    multiUser: false,
    customBranding: false,
    analytics: "none",
    productRecommendations: false,
  },
  garden_center: {
    designsPerDay: -1,
    stylesAvailable: "all",
    seasonalViews: true,
    realTimeEditing: true,
    savedDesigns: -1,
    emailRequired: false,
    inventoryIntegration: true,
    clientManagement: true,
    proposalGeneration: false,
    multiUser: true,
    customBranding: true,
    analytics: "basic",
    productRecommendations: true,
  },
  landscaper: {
    designsPerDay: -1,
    stylesAvailable: "all",
    seasonalViews: true,
    realTimeEditing: true,
    savedDesigns: -1,
    emailRequired: false,
    inventoryIntegration: true,
    clientManagement: true,
    proposalGeneration: true,
    multiUser: true,
    customBranding: true,
    analytics: "advanced",
    productRecommendations: true,
  },
};

export function getFeaturesForTenant(type: string): FeatureFlags {
  return FEATURE_CONFIGS[type] || FEATURE_CONFIGS.consumer;
}
